<template>
  <div class="content">
    <div class="iconWrapper">
      <i class="icon bi bi-exclamation" />
    </div>
    <div class="title">{{ $t("game.preGameModalWaitingError.title") }}</div>
    <div class="subtitle"><slot name="text"></slot></div>
    <Button class="primary" :label="$t('game.preGameModalWaitingError.button')" @click="$emit('back')" />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.content {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: center;

  .iconWrapper {
    width: 64px;
    height: 64px;

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    font-size: 48px;

    background-color: #f40000;
  }

  .title {
    font-size: 32px;
    font-weight: 700;

    margin: 8px 0;

    @media screen and (max-width: $small-screen) {
      font-size: 20px;
    }
  }

  .subtitle {
    font-size: 18px;
    text-align: center;

    @media screen and (max-width: $small-screen) {
      font-size: 16px;
    }

    :deep(b) {
      font-weight: 700;
      color: #f2cb36;
    }
  }

  .btn {
    margin-top: 40px;
  }
}
</style>

<script setup lang="ts"></script>
